module.exports = __webpack_public_path__ + "static/yt_3@1x-3bd360e27de418ac3881045650b29b3b.jpg";